import React from 'react';
import styled from 'styled-components';
import * as FormUI from '../../pages/pageForm/FormUI';
import RenamedIndicator from '../RenamedIndicator';

interface IProps {
  value: string;
  isBold?: boolean;
  isRenamed?: boolean;
}

const StyledRenamedIndicator = styled(RenamedIndicator)`
  margin-left: 4px;
`;

const EditableTextAreaValue = ({ value, isBold, isRenamed }: IProps) => {
  const truncatedValue =
    value.length < 280 ? value : `${value.slice(0, 280)}...`;

  return (
    <FormUI.OverflowingTextWrapper $isBold={isBold} title={value}>
      {truncatedValue}
      {isRenamed && <StyledRenamedIndicator />}
    </FormUI.OverflowingTextWrapper>
  );
};

export default EditableTextAreaValue;
